
import styles from "../../../../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getStudentsHistoryPayData, getCoursesData, getContractAmountsData, getStudentsDetailData, getStudentsContractData } from "service/AccountingService";
const StudentHystoryPayContent = ({ render, setRender, id }) => {
  const { t } = useTranslation('common')

  const componentRef = useRef();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const [contractamounts, setContractAmounts] = useState([]);
  const getContractAmounts = async (departmentId, yearId, typeId) => {
    try {
      const response = await getContractAmountsData(yearId, departmentId, typeId);
      setContractAmounts(response.data);

    } catch (error) {
    }
  };
  const [courses, setCourses] = useState([]);
  const getCourses = async (id) => {
    try {
      let response = await getCoursesData(id, courses);
      setCourses(response.data);

    } catch (error) {
    }
  };
  const [datacontract, setDataContract] = useState([]);
  const getDataContract = async (id) => {
    try {
      let response = await getStudentsContractData(id, datacontract);
      setDataContract(response.data);
    } catch (error) {
    }
  };
  const [datahistory, setDataHistory] = useState([]);
  const getDataHistory = async (id) => {
    try {
      let response = await getStudentsHistoryPayData(id, datahistory);
      setDataHistory(response.data);
    } catch (error) {
    }
  };
  const [datastudent, setData] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getStudentsDetailData(id, datastudent);
      setData(response.data);
      if (response.data.academic_year && response.data.departmentID && response.data.educationtype) {
        getDataHistory(id);
        getDataContract(id);
        getCourses(response.data.fund)
        getContractAmounts(response.data.departmentID, response.data.academic_year, response.data.educationtype);
      }

    } catch (error) {
    }
  };


  useEffect(() => {
    getData(id)
    setRender(false);
  }, [render]);


  return (
    <>


      <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
          <table className={styles.table__wrapper}>
            <thead className={styles.table__head}>
              <tr className={styles.table__row}>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>{t('auth.inn')}</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>{t('user.last_name')}</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>{t('user.first_name')}</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>{t('archive.col_specialty')}</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>{t('auto.components_educationtypecontent.k1')}</span>
                </th>
                <th className={styles.table__item_contract}>
                  <span className={styles.table__title}>{t('distance.datetime_label')}</span>
                </th>
              </tr>
            </thead>
            <tbody className={styles.table__body}>
              <tr className={styles.table__row}>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.inn}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.surname}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.first_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.speciality_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>{datastudent.educationtype_name}</span>
                </td>
                <td className={styles.table__item_contract}>
                  <span className={styles.table__title}>
                    {new Date().toLocaleString("ru-RU", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className={styles.project__h}>{t('auto.components_studenthystorypaylistcontent.k1')}</h3>
          <hr style={{ borderTop: '2px solid #444', margin: '20px 0 0 0' }} />
        </div>

        <table className={styles.table__wrapper}>

          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>{t('dpo.course')}</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>{t('pages.enrollTab.funding_contract')}</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>{t('auto.components_studenthystorypaylistcontent.k2')}</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>{t('auto.components_studenthystorypaylistcontent.k3')}</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>{t('auto.components_studenthystorypaylistcontent.k4')}</span>
              </th>
              <th className={styles.table__item_contract}>
                <span className={styles.table__title}>{t('auto.components_studenthystorypaylistcontent.k5')}</span>
              </th>
            </tr>
          </thead>

          <tbody className={styles.table__body}>
            {courses.map((itemcourse) => {

              const contractMatch = contractamounts.find(
                (contract) =>
                  contract.speciality === datastudent.speciality &&
                  contract.course === itemcourse.id
              );

              const benefitMatch = datacontract.find(
                (history) => history.course === itemcourse.id
              );

              const coursePayments = datahistory.filter(
                (payment) => payment.course === itemcourse.id
              );

              const contractAmount = contractMatch
                ? parseFloat(contractMatch.amount)
                : null;

              const discountPercent = benefitMatch && benefitMatch.benefits
                ? parseFloat(benefitMatch.benefits.replace("%", "").replace(",", "."))
                : 0;

              const discountedAmount = contractAmount !== null
                ? contractAmount - (contractAmount * discountPercent) / 100
                : null;

              const totalPaid = coursePayments.reduce(
                (sum, p) => sum + parseFloat(p.amount || 0),
                0
              );

              const remaining = discountedAmount !== null
                ? discountedAmount - totalPaid
                : null;

              return (
                <React.Fragment key={itemcourse.id}>

                  <tr className={styles.table__row}>
                    <td className={styles.table__item_contract} style={{ fontWeight: "700" }}>
                      <span className={styles.table__title}>{itemcourse.name} курс</span>
                    </td>
                    <td className={styles.table__item_contract}>
                      <span className={styles.table__title}>
                        {contractAmount !== null
                          ? contractAmount
                          : "не указан"}
                      </span>
                    </td>
                    <td className={styles.table__item_contract}>
                      <span className={styles.table__title}>
                        {benefitMatch && benefitMatch.benefits
                          ? benefitMatch.benefits
                          : "не указано"}%
                      </span>
                    </td>
                    <td className={styles.table__item_contract}>
                      <span className={styles.table__title}>
                        {contractAmount !== null
                          ? discountedAmount.toFixed(2)
                          : "не указано"}
                      </span>
                    </td>
                    <td className={styles.table__item_contract}>
                      <span className={styles.table__title}>
                        {coursePayments.length > 0 ? totalPaid.toFixed(2) : "0.00"}
                      </span>
                    </td>
                    <td className={styles.table__item_contract}>
                      <span className={styles.table__title}>
                        {contractAmount !== null
                          ? remaining.toFixed(2)
                          : "не указано"}
                      </span>
                    </td>
                  </tr>

                  
                  {coursePayments.length > 0 && (
                    <tr>
                      <td colSpan={6} style={{ padding: 0 }}>
                        <table className={styles.table__wrapper}>
                          <thead className={styles.table__head}>
                            <tr className={styles.table__row}>
                              <th className={styles.table__item_student_history}>
                                <span className={styles.table__title}>{t('auto.components_studenthystorypaylistcontent.k6')}</span>
                              </th>
                              <th className={styles.table__item_student_history}>
                                <span className={styles.table__title}>{t('dorm.field_amount')}</span>
                              </th>
                              <th className={styles.table__item_student_history}>
                                <span className={styles.table__title}>{t('pages.ordersPage.ground')}</span>
                              </th>
                              <th className={styles.table__item_student_history}>
                                <span className={styles.table__title}>{t('auto.components_studenthystorypaycontent.k2')}</span>
                              </th>
                              <th className={styles.table__item_student_history}>
                                <span className={styles.table__title}>{t('auto.components_studenthystorypaylistcontent.k7')}</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className={styles.table__body}>
                            {coursePayments.map((item, index) => (
                              <tr className={styles.table__row} key={item.id}>
                                <td className={styles.table__item_student_history}>
                                  <span className={styles.table__title}>{item.order}</span>
                                </td>
                                <td className={styles.table__item_student_history}>
                                  <span className={styles.table__title}>{item.amount}</span>
                                </td>
                                <td className={styles.table__item_student_history}>
                                  <span className={styles.table__title}>{item.base}</span>
                                </td>
                                <td className={styles.table__item_student_history}>
                                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                    {item.date}
                                  </span>
                                </td>
                                <td className={styles.table__item_student_history}>
                                  <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                    {item.date_сreate}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={6}>
                      <hr style={{ borderTop: '2px solid #444', margin: '20px 0' }} />
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>

        </table>
      </div>


    </>


  );
};

export default StudentHystoryPayContent;
